import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "formatPhone",
})
export class FormatPhonePipe implements PipeTransform {
    extractNumbers(input: string) {
        return input.replace(/[^\d]/g, "");
    }

    parseCountryCode(phone: string, end: number) {
        let countryCode = phone.substring(0, end);

        if (countryCode.length > 3) {
            if (countryCode.substring(0, 1) === "1") {
                countryCode = `${countryCode.substring(0, 1)}-${countryCode.substring(1)}`;
            } else if (countryCode.substring(0, 2) === "44") {
                countryCode = `${countryCode.substring(0, 2)}-${countryCode.substring(2)}`;
            }
        }

        return countryCode;
    }

    format10DigitNumber(phone: string) {
        return `(${phone.substring(0, 3)}) ` + phone.substring(3, 6) + (phone.length > 6 ? "-" : "") + phone.substring(6, 10);
    }

    transform(phone: string, format?: string): string {
        let newPhone = this.extractNumbers(phone) + "";
        const end = newPhone.length - 10;
        const countryCode = this.parseCountryCode(newPhone, end) || "1";
        let _format = format;

        if (newPhone === "911" || newPhone === "") {
            _format = null;
        }

        if (newPhone.length > 10) {
            newPhone = newPhone.substring(end);
        }

        switch (_format) {
            case "x (xxx) xxx-xxxx":
                return `${countryCode} ${this.format10DigitNumber(newPhone)}`;

            case "(xxx) xxx-xxxx":
                return this.format10DigitNumber(newPhone);

            case "(xxx)xxx-xxxx":
                return this.format10DigitNumber(newPhone).replace(" ", "");

            default:
                // Strip formatting
                if (newPhone.length === 10) {
                    return countryCode.replace("-", "") + newPhone;
                }
        }

        return newPhone;
    }
}
